import { Get, Set } from "../../../../../Request";

export const GetData = async data => {
  return await Get({
    url: "/client/show_financial_information",
  }).then(data => {
    return data;
  });
};

export const EditeMoney = async data => {
  return await Get({
    url: "/client/financial_information",
    stat: true,

    data: data,
  }).then(data => {
    return data;
  });
};
